module.exports = __webpack_public_path__ + "static/media/no_gl_seal_light.0b117dce.png";